import React, { useEffect, useState } from "react";
import Constants from "../../utils/constants";
import moment from "moment";
import "./styles.scss";
import Pillar from "../../components/Pillar";

const { LANGUAGES } = Constants;
const { minute, noScheduled } = LANGUAGES;

const StationTitle = (props) => {
  const {
    title,
    time,
    timestamp,
    notes,
    index,
    type,
    isLastStation,
    remarks,
    court,
    color,
    themeColour,
    showLicensePlate,
    licensePlate
  } = props;

  const [language, setLanguage] = useState(props.language);

  useEffect(() => {
    setLanguage(props.language);
  }, [props.language]);

  const getPosition = (index) => {
    if (index === 0) {
      return "first";
    } else if (index > 0 && isLastStation) {
      return "last";
    } else {
      return "middle";
    }
  };

  const renderTime = (time, timestamp, licensePlate) => {
    if (typeof time === "number") {
      if (time > 90) {
        let etaMoment = moment().add(time, "minute");
        if (timestamp) {
          etaMoment = moment(timestamp);
        }
        return (
          <span className="time smaller-text">
            {etaMoment.format("HH:mm")}
          </span>
        );
      } else {
        return (
          <>
            {/* Check whether "Scheduled in remarks_en field in api" */}
            <span className={`time`} style={!remarks?{color: `${themeColour || "#3399ff"}`}:{}}>
              {time >= 0 ? time : "-"}
            </span>
            <span className="minute">{minute[language]}</span>
            {remarks && <span className="remarks">{`(${remarks})`}</span>}
            {(showLicensePlate && licensePlate) && <span className="remarks">{`(${licensePlate})`}</span>}
          </>
        );
      }
    } else {
      return (
        <>
          <span className="time" style={{ color: themeColour }}>-</span>
          <span className="minute">{minute[language]}</span>
        </>
      );
    }
  };

  return (
    <div className="station-title-container">
      <div className="dot-container">
        <div
          className={`dot ${court}`}
          style={{ backgroundColor: "#000 !important" }}
        >
          {getPosition(index) === "first" ? (
            <Pillar position={"lower"} color={color || themeColour} />
          ) : getPosition(index) === "middle" ? (
            <>
              <Pillar position={"upper"} color={color || themeColour} />
              <Pillar position={"lower"} color={color || themeColour} />
            </>
          ) : (
            <Pillar position={"upper"} color={color || themeColour} />
          )}
        </div>
        <div className="station">
          <div>
            <span className={`name ${language}`}>{title}</span>
            {notes ? <span className="note">({notes})</span> : null}
          </div>
        </div>
      </div>
      <div>
        {typeof time === "number" ? (
          <div className="station">{renderTime(time, timestamp, licensePlate)}</div>
        ) : (
          <div className="station schedule">
            <span className="schedule-text"></span>
            <span className="time smaller-text">{noScheduled[language]}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StationTitle;
